import React from "react"
import {
  timesActivity,
  countryActivity,
  costActivity,
  numWinners
} from "../../../constants/activity-constants"

import iconV from "../../../assets/images/iconV.png"
import logoVNosotras from "../../../assets/images/logoVNosotras.png"

import useMediaQuery from "../../../utils/useMediaQuery"

import "./terms.scss"
export default function Terms() {
  const isMobile = useMediaQuery()

  const termsList = [
    <>
      Todas las participantes de esta actividad deben estar registradas en{" "}
      <span className="family-Bw-Black">NosotrasOnline.com.</span>
    </>,
    <>
      Para jugar, las participantes deberán{" "}
      <span className="family-Bw-Black">redimir {costActivity} puntos</span> de
      su cuenta en <b>NosotrasOnline.com.</b>
    </>,
    <>
      Los mejores {numWinners} puntajes ganarán: 1 Calendario 2022 y 1 Kit
      Nosotras: Protectores Diarios Largos Alas x 20, Pañitos Húmedos Íntimos
      BIO Sensiti-V x16, Pañitos Húmedos Íntimos BIO Herbal x16, Protectores
      Diarios Multiestilo x 200, Toalla Buenas Noches Máxima Protección talla M
      x 3, Toallas Invisible Nosotras Multiestilo x 24.
    </>,
    <>
      Todas las imágenes de los premios que están en el sitio, son para
      ejemplificarlos, son solo imágenes de referencia.
    </>,
    <>
      En caso de que la participante no pueda recibir el premio, no tendrá
      derecho a ningún otro producto diferente ni a ningún tipo de indemnización
      o compensación.
    </>,
    <>
      Los premios no son acumulables con otras promociones o actividades, no son
      intercambiables por dinero ni son canjeables por ningún otro concepto o
      producto identificado con la marca Nosotras ® o de Productos Familia S.A.
    </>,
    <>
      La marca Nosotras tiene el derecho de anular o descalificar cualquier
      material que considere que no cumple con las reglas del concurso. Así
      mismo, procederá con el material que no tenga relación con la mecánica de
      la actividad, que considere no apto o que atente contra los valores de la
      marca.
    </>,
    <>
      Con el hecho de participar en la actividad, las ganadoras aceptan y
      autorizan que su nombre y sus imágenes aparezcan en las publicaciones y
      demás material de divulgación con fines promocionales que los
      organizadores deseen hacer durante el concurso o una vez este finalice,
      sin que ello implique la obligación de remunerarlas o compensarlas
    </>,
    <>
      El hecho de que la usuaria participe en la dinámica implica el
      conocimiento y la aceptación de las condiciones establecidas en
      reglamento, página web y correo electrónico.
    </>,
    <>
      La actividad estará al aire desde el{" "}
      <span className="family-Bw-Black">
        {timesActivity.inicio.dia} de {timesActivity.inicio.mes} al{" "}
        {timesActivity.fin.dia} de {timesActivity.fin.mes} de{" "}
        {timesActivity.fin.año}.
      </span>
    </>,
    <>
      Los nombres de las ganadoras se publicarán entre{" "}
      {timesActivity.ganadoras.dia} de {timesActivity.ganadoras.mes} de{" "}
      {timesActivity.ganadoras.año}.
    </>,
    <>
      Una vez finalizada la actividad, las ganadoras deberán entregar los
      empaques de las claves con las que participaron. La marca se pondrá en
      contacto con ellas para informarles sobre la dinámica de entrega. Después
      de que la marca se ponga en contacto con ellas, las usuarias tendrán un
      mes de plazo para enviar los empaques y reclamar los premios.
    </>,
    <>
      Concurso válido solo para usuarias de Colombia, Perú, Bolivia, Puerto
      Rico, República Dominicana, Paraguay, Uruguay, Argentina, Chile y Ecuador.
    </>
  ]

  return (
    <div className="terms">
      <div className="terms__container">
        {isMobile && <img src={logoVNosotras} />}
        <div className="terms__container-terms">
          <h2 className="family-Bw-Black size-40 color-white">
            TÉRMINOS <br />Y CONDICIONES
          </h2>
          <img src={iconV} />
          {termsList.map((term, index) => {
            return (
              <p className="family-H-Medium size-15 color-white" key={index}>
                <span className="family-Bw-Black color-white">
                  {index + 1}.{" "}
                </span>
                {term}
              </p>
            )
          })}
          <p className="family-H-Medium size-14 color-white">
            En caso de tener dudas, o si quieres recibir mayor información,
            comunícate con nosotras por nuestras redes sociales o a{" "}
            <a
              href="https://www.nosotrasonline.com.co/contactanos/"
              target="__blank"
            >
              https://www.nosotrasonline.com.co/contactanos/
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
